export default {
  serviceName: '/breeze/data',
  pageSize: 100,
};
